import { call, put, all, takeEvery, select } from "redux-saga/effects";

import { newsCategoriesActions } from '../slice/newsCategoriesSlice'
import { getAllApi, getAllByAdminApi, createApi, updateApi, deleteApi } from 'services/newsCategoriesServices'
import { newsCategoriesSelector } from "redux/selector"


function* handleGetNewsCategoriesAll() {
    try {
        const res = yield call(getAllApi)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsCategoriesActions.getNewsCategoriesAllSuccess({ data: response.data }))
            }
            else {
                yield put(newsCategoriesActions.getNewsCategoriesAllFailed())
            }
        }
        else {
            yield put(newsCategoriesActions.getNewsCategoriesAllFailed())
        }
    } catch (error) {
        yield put(newsCategoriesActions.getNewsCategoriesAllFailed())
    }
}


function* handleGetNewsCategories(action) {
    try {
        const res = yield call(getAllByAdminApi, action.payload.currentPage)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsCategoriesActions.getNewsCategoriesSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(newsCategoriesActions.getNewsCategoriesFailed())
            }
        }
        else {
            yield put(newsCategoriesActions.getNewsCategoriesFailed())
        }
    } catch (error) {
        yield put(newsCategoriesActions.getNewsCategoriesFailed())
    }
}


function* handleCreateNewsCategories(action) {
    try {
        const res = yield call(createApi, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsCategoriesActions.addNewsCategoriesSuccess())
                action.payload.ShowToast('success', 'Thêm loại bài viết thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(newsCategoriesActions.getNewsCategories({ currentPage: action.payload.currentPage }))
            } else {
                yield put(newsCategoriesActions.addNewsCategoriesFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Thêm loại bài viết thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(newsCategoriesActions.addNewsCategoriesFailed())
            action.payload.ShowToast('error', 'Thêm loại bài viết thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(newsCategoriesActions.addNewsCategoriesFailed())
        action.payload.ShowToast('error', 'Thêm loại bài viết thất bại, vui lòng thử lại sau!')
    }
}


function* handleUpdateNewsCategory(action) {
    try {
        const res = yield call(updateApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsCategoriesActions.updateNewsCategoriesSuccess())
                action.payload.ShowToast('success', 'Cập nhật loại bài viết thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(newsCategoriesActions.getNewsCategories({ currentPage: action.payload.currentPage }))

            } else {
                yield put(newsCategoriesActions.updateNewsCategoriesFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Cập nhật loại bài viết thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(newsCategoriesActions.updateNewsCategoriesFailed())
            action.payload.ShowToast('error', 'Cập nhật loại bài viết thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(newsCategoriesActions.updateNewsCategoriesFailed())
        action.payload.ShowToast('error', 'Cập nhật loại bài viết thất bại, vui lòng thử lại sau!')
    }
}



function* handleRemoveNewsCategories(action) {
    try {
        const res = yield call(deleteApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsCategoriesActions.removeNewsCategoriesSuccess())
                const newsCategoriesState = yield select(newsCategoriesSelector)
                let totalPage = newsCategoriesState.totalPage
                if (newsCategoriesState.newsCategoriesList.length === 1) {
                    totalPage = totalPage - 1
                    yield put(newsCategoriesActions.setTotalPage(totalPage))
                    action.payload.setCurrentPage(action.payload.currentPage - 1)
                    yield History.navigate(`/admin/news-category?page=${action.payload.currentPage - 1}`);
                }
                action.payload.ShowToast("success", 'Xóa loại bài viết thành công!')
                yield put(newsCategoriesActions.getNewsCategories({ currentPage: action.payload.currentPage }))
            } else {
                yield put(newsCategoriesActions.removeNewsCategoriesFailed())
                action.payload.ShowToast('error', `${response.data[1]}`)
            }
        }
        else {
            yield put(newsCategoriesActions.removeNewsCategoriesFailed())
            action.payload.ShowToast('error', `Xóa loại bài viết thất bại, loại bài viết đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
        }
    } catch (error) {
        yield put(newsCategoriesActions.removeNewsCategoriesFailed())
        action.payload.ShowToast('error', `Xóa loại bài viết thất bại, loại bài viết đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
    }
}


export default function* newsCategoriesSaga() {
    yield all(
        [
            takeEvery(newsCategoriesActions.getNewsCategories.type, handleGetNewsCategories),
            takeEvery(newsCategoriesActions.getNewsCategoriesAll.type, handleGetNewsCategoriesAll),
            takeEvery(newsCategoriesActions.addNewsCategories.type, handleCreateNewsCategories),
            takeEvery(newsCategoriesActions.updateNewsCategories.type, handleUpdateNewsCategory),
            takeEvery(newsCategoriesActions.removeNewsCategories.type, handleRemoveNewsCategories),
        ]
    )
}
